// extracted by mini-css-extract-plugin
export default {"countdown":"WY-z","srOnly":"XY-z"};